/* eslint-disable */
import authCurrentSelector from './AuthCurrent.selector';

/**
 * Select the expiry of the current `AuthEntity`'s `accessToken`
 * @param {any} state The state management `state`
 * @returns {number} The remaining duration for the `accessToken`
 */
const authExpirySelector = (state) => {
  const auth = authCurrentSelector(state);
  if (auth === null) {
    return 0;
  }
  return auth.accessToken.expiresAt;
};

export default authExpirySelector;
